import { Component, Watch, Vue } from 'vue-property-decorator'
import * as TEXTTOSPEECH from '@/@next/store/textToSpeech'
import * as SETTINGS from '@/@next/store/settings2/types'

import { Getter, Mutation, Action } from 'vuex-class'

@Component({ name: 'text-to-speech-mixin' })
export default class TextToSpeech extends  Vue {

  currenText: string = ''
  currentElement: HTMLElement | null = null
  isPlaying: boolean = false

  @Action(TEXTTOSPEECH.ADD_ITEM) addTtsItem!: any
  @Action(TEXTTOSPEECH.REMOVE_ITEM) removeTtsItem!: any
  @Action(TEXTTOSPEECH.CLICK_ON_ITEM) clickOnTtsItem!: any
  @Action(TEXTTOSPEECH.RESET) resetTts!: any
  @Action(TEXTTOSPEECH.READ_LIST) readTtsList!: any
  @Action(TEXTTOSPEECH.PAUSE) pauseTts!: any
  @Action(TEXTTOSPEECH.RESUME) resumeTts!: any
  @Action(TEXTTOSPEECH.STOP) stopTts!: any
  @Action(TEXTTOSPEECH.PLAY) playTts!: any
  @Getter(TEXTTOSPEECH.GET_IS_PAUSED) ttsIsPaused!: boolean
  @Getter(TEXTTOSPEECH.GET_IS_STARTED) ttsIsStarted!: boolean
  @Getter(TEXTTOSPEECH.HAS_NEXT) hasNextTts!: boolean
  @Getter(TEXTTOSPEECH.HAS_PREV) hasPreviousTts!: boolean
  @Action(TEXTTOSPEECH.NEXT) readNextTts!: any
  @Action(TEXTTOSPEECH.PREV) readPreviousTts!: any
  @Getter(TEXTTOSPEECH.SHOW_CONTROLS) showTtsControls!: any
  @Getter(TEXTTOSPEECH.ENABLE_ON_USER_SETTINGS) isEnabledOnUserSettings!: boolean
  @Mutation(TEXTTOSPEECH.ENABLE_ON_USER_SETTINGS) enableOnUserSettings!: any
  
  @Getter(SETTINGS.GET_FEATURES) _settingsFeatures!: any

  get ttsIsNeeded () {
    return  this.isEnabledOnUserSettings || this._settingsFeatures?.includes('textToSpeech')
  }

  get ttsIsAvailableOnDevice () {
    return ('speechSynthesis' in window)
  }

  get allowTts () {
    return this.ttsIsNeeded && this.ttsIsAvailableOnDevice
  }

}
